<template>
  <v-container class="pessoas">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <v-form>
        <PageTitle
          main="Compras e licitações"
          icon="mdi-pencil-box-outline"
          sub="Cadastro de fornecedor"
          home="/compras"
        />
        <Cadastro />
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import Cadastro from '@/modules/admin/cadastros/fornecedor'
export default {
  name: 'Pessoas',
  components: { PageTitle, Cadastro },
  data: () => ({

  })
}
</script>
